import { Field } from 'formik';
import React, { ReactElement, useCallback } from 'react';
import './pillcheckbox.module.scss';
import CustomTooltip from '../Tooltip/Tooltip';
export interface IInputItem {
  Title: string;
  Id: string;
  Tooltip?: string;
}
export interface IPillCheckboxProps {
  items?: IInputItem[];
  name: string;
}

const PillCheckbox = (props: IPillCheckboxProps): ReactElement => {
  let { items, name } = props;

  // Handles Enter and Spacebar.
  const handleKeyDown = useCallback((e) => {
    if ([13, 32].includes(e.keyCode)) {
      e.preventDefault();
      e.target.click();
    }
  }, []);

  items = items.sort((a, b) => a.Title.localeCompare(b.Title));

  return (
    <>
      {items?.map((item: IInputItem) => {
        const { Id, Title, Tooltip } = item;
        return (
          <React.Fragment key={Id}>
            <Field type="checkbox" id={Id} value={Id} name={name} className="form-input-checkbox pill" />
            {/* Adds tabIndex={0} because label is not focusable by default */}
            <label htmlFor={Id} onKeyDown={handleKeyDown} tabIndex={0}>
              {Tooltip ? <CustomTooltip tooltipText={Tooltip}>{Title}</CustomTooltip> : <>{Title}</>}
            </label>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default PillCheckbox;
